// extracted by mini-css-extract-plugin
export default {"wrapper":"BadgeButton_wrapper__8AfDe","badge":"BadgeButton_badge__z0Hpq"};